const merchants_buttons = document.querySelectorAll('.merchants__button.custom-button');
if (merchants_buttons) {
	merchants_buttons.forEach((btn) => {
		btn.addEventListener('click', () => {
			document.dispatchEvent(new CustomEvent('open:storeLocator'));
		});
	});
}
